import './TextArea.scss';
import { forwardRef, HTMLAttributes, useId } from 'react';
import classNames from 'classnames';
import { FormHelperText } from '@mui/material';
import { ErrorWidget } from 'app/agriculture/error_widget';
import { InputLabel } from 'app/agriculture/forms/components/InputLabel/InputLabel';

interface TextAreaProps {
    className?: string;
    label: string;
    labelProps?: HTMLAttributes<HTMLLabelElement>;
    errorMessage?: string;
    defaultValue?: any;
}

export const TextArea = forwardRef<
    HTMLTextAreaElement,
    HTMLAttributes<HTMLTextAreaElement> & TextAreaProps
>(function TextArea({ className, label, errorMessage, labelProps, ...inputBaseProps }, ref) {
    const labelId = useId();
    return (
        <div className="TextArea">
            <InputLabel id={labelId} className="TextArea__label" {...labelProps}>
                {label}
            </InputLabel>
            <textarea
                {...inputBaseProps}
                aria-labelledby={labelId}
                className={classNames('TextArea__input', className)}
                ref={ref}
            />
            {errorMessage == null ? null : (
                <FormHelperText className="TextArea__error" error={true}>
                    <ErrorWidget errorMessage={errorMessage} />
                </FormHelperText>
            )}
        </div>
    );
});
